import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "container-fluid redCheckoutSuccess-container1 bg-brand_beige_light" };
const _hoisted_2 = { class: "container pb-5" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-12 mt-5 text-center" };
const _hoisted_5 = {
    key: 0,
    class: "mb-4"
};
const _hoisted_6 = ["href"];
const _hoisted_7 = { class: "container redCheckoutSuccess-container2 mt-n5 pb-4" };
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "schickMichMitSchein col-lg-8 offset-lg-2 mb-3 d-flex" };
const _hoisted_10 = { class: "col-12 bg-white border rounded py-3" };
const _hoisted_11 = { class: "row" };
const _hoisted_12 = { class: "col-12 mt-3" };
const _hoisted_13 = ["href"];
const _hoisted_14 = {
    key: 0,
    class: "versandLabel col-lg-8 offset-lg-2 mb-3 d-flex"
};
const _hoisted_15 = { class: "col-12 bg-white border rounded py-3" };
const _hoisted_16 = { class: "row" };
const _hoisted_17 = {
    class: "qrCodeBox col-12 col-sm-6 mt-3 mb-sm-0 mb-5 d-flex",
    style: { "flex-direction": "column" }
};
const _hoisted_18 = { class: "row" };
const _hoisted_19 = { class: "col-sm-11" };
const _hoisted_20 = {
    key: 0,
    class: "font6-responsive"
};
const _hoisted_21 = {
    key: 1,
    class: "font6-responsive"
};
const _hoisted_22 = {
    class: "row",
    style: { "flex-grow": "2" }
};
const _hoisted_23 = { class: "col-sm-11 mb-3" };
const _hoisted_24 = { class: "row justify-content-center" };
const _hoisted_25 = ["src"];
const _hoisted_26 = { class: "row" };
const _hoisted_27 = { class: "col-sm-11" };
const _hoisted_28 = ["href"];
const _hoisted_29 = {
    class: "versandscheinBox col-12 col-sm-6 mt-sm-3 mt-0 pb-sm-0 d-flex",
    style: { "flex-direction": "column" }
};
const _hoisted_30 = { class: "row" };
const _hoisted_31 = { class: "col-sm-11 offset-sm-1" };
const _hoisted_32 = ["href"];
const _hoisted_33 = { class: "paketStation col-lg-8 offset-lg-2 mb-3 d-flex" };
const _hoisted_34 = { class: "col-12 bg-white border rounded py-3" };
const _hoisted_35 = { class: "row border-bottom" };
const _hoisted_36 = { class: "col-12 pr-0" };
const _hoisted_37 = {
    key: 0,
    class: "h5 mb-3"
};
const _hoisted_38 = { key: 0 };
const _hoisted_39 = { key: 1 };
const _hoisted_40 = {
    key: 1,
    class: "h5 mb-3"
};
const _hoisted_41 = { class: "row" };
const _hoisted_42 = { class: "col-12 mt-3" };
const _hoisted_43 = {
    key: 0,
    class: "font6-responsive"
};
const _hoisted_44 = {
    key: 1,
    class: "font6-responsive"
};
const _hoisted_45 = { key: 0 };
const _hoisted_46 = { key: 1 };
const _hoisted_47 = {
    key: 1,
    class: "schickMichMitSchein col-lg-8 offset-lg-2 mb-3 d-flex"
};
const _hoisted_48 = { class: "col-12 bg-white border rounded pb-3" };
const _hoisted_49 = { class: "row" };
const _hoisted_50 = { class: "col-12 mt-4" };
const _hoisted_51 = ["href"];
const _hoisted_52 = {
    key: 2,
    class: "myswooopAdress col-lg-8 offset-lg-2 mb-3 d-flex"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_checkout_success_thanks = _resolveComponent("checkout-success-thanks");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_checkout_success_thanks, {
                            "customer-email": _ctx.customerEmail,
                            "customer-first-name": _ctx.customerFirstName,
                            "transaction-id": _ctx.order.id
                        }, null, 8, ["customer-email", "customer-first-name", "transaction-id"]),
                        (_ctx.isMobile)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                                _createElementVNode("a", {
                                    href: `/verkaufen/checkout/downloadAllAssets/${_ctx.order.id}`,
                                    download: "",
                                    target: "_blank",
                                    class: "buttonBase buttonBlueInverted w-100 font5-responsive [ track_red_alldocuments ]"
                                }, " Dokumente herunterladen ", 8, _hoisted_6)
                            ]))
                            : _createCommentVNode("", true),
                        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "h2-responsive mb-3 mb-md-5 mt-2" }, "Wir freuen uns auf Dein Paket - So geht's weiter:", -1))
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
                _createElementVNode("article", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row border-bottom" }, [
                            _createElementVNode("div", { class: "col-12 pr-0" }, [
                                _createElementVNode("h3", { class: "h5 mb-3" }, "1. Checkliste abhaken")
                            ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "font6-responsive" }, " Auf der Checkliste findest Du nützliche Hinweise, um Dein Gerät auf den Verkauf vorzubereiten. ", -1)),
                                _createElementVNode("a", {
                                    href: `/verkaufen/checkliste/${_ctx.order.id}`,
                                    class: _normalizeClass(["buttonBase buttonBlueInverted w-100 [ track_red_checklist ]", { downloadButtonMobileView: _ctx.isMobile }]),
                                    download: "",
                                    target: "_blank"
                                }, " Checkliste speichern ", 10, _hoisted_13)
                            ])
                        ])
                    ])
                ]),
                (_ctx.dhlLabelServed)
                    ? (_openBlock(), _createElementBlock("article", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row border-bottom" }, [
                                _createElementVNode("div", { class: "col-12 pr-0" }, [
                                    _createElementVNode("h3", { class: "h5 mb-3" }, "2. Mit oder ohne Drucker")
                                ])
                            ], -1)),
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("div", _hoisted_19, [
                                            (_ctx.order.pickupDate)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, " Einfach den QR-Code bei der Abholung vorzeigen. DHL druckt das Versandlabel für Dich. "))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_21, " Einfach den QR-Code beim Paketshop vorzeigen. DHL druckt dort das Versandlabel für Dich. "))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("div", _hoisted_24, [
                                                _createElementVNode("img", {
                                                    class: "qrcode",
                                                    src: `/dhl/qrcode/${_ctx.order.id}`,
                                                    title: "Ihr persönlicher mySWOOOP QR-Code für den Versand an uns"
                                                }, null, 8, _hoisted_25)
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("div", _hoisted_27, [
                                            _createElementVNode("a", {
                                                href: `/dhl/qrcode/${_ctx.order.id}`,
                                                download: "",
                                                target: "_blank",
                                                class: _normalizeClass(["buttonBase buttonBlueInverted w-100 [ track_red_qrcode ]", { downloadButtonMobileView: _ctx.isMobile }]),
                                                title: "QR-Code herunterladen"
                                            }, " QR-Code speichern ", 10, _hoisted_28)
                                        ])
                                    ]),
                                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "orSign" }, "oder", -1))
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"row\" data-v-91a4306e><div class=\"col-sm-11 offset-sm-1\" data-v-91a4306e><p class=\"font6-responsive\" data-v-91a4306e> Das Versandlabel ausdrucken und auf Dein Paket kleben. </p></div></div><div class=\"row d-none d-sm-flex\" style=\"flex-grow:2;align-items:flex-end;\" data-v-91a4306e><div class=\"col-sm-11 offset-sm-1 mb-3\" data-v-91a4306e><div class=\"row justify-content-center\" data-v-91a4306e><img class=\"versandschein\" src=\"/images/checkout/Versandschein.png\" title=\"Versandschein\" data-v-91a4306e></div></div></div>", 2)),
                                    _createElementVNode("div", _hoisted_30, [
                                        _createElementVNode("div", _hoisted_31, [
                                            _createElementVNode("a", {
                                                href: `/dhl/label/${_ctx.order.id}`,
                                                download: "",
                                                target: "_blank",
                                                class: _normalizeClass(["buttonBase buttonBlueInverted w-100 [ track_red_shippinglabel ]", { downloadButtonMobileView: _ctx.isMobile }]),
                                                id: "vs",
                                                title: "Versandschein herunterladen"
                                            }, " Versandlabel speichern ", 10, _hoisted_32)
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("article", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                                (_ctx.dhlLabelServed)
                                    ? (_openBlock(), _createElementBlock("h3", _hoisted_37, [
                                        (_ctx.order.pickupService)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_38, "3. Paket an DHL übergeben"))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_39, "3. Versenden"))
                                    ]))
                                    : (_openBlock(), _createElementBlock("h3", _hoisted_40, "2. Finde einen Paketshop in Deiner Nähe"))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                                (_ctx.order.pickupDate)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_43, [
                                        _cache[6] || (_cache[6] = _createTextVNode(" Dein Paket wird am ", -1)),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.order.pickupDate), 1),
                                        _cache[7] || (_cache[7] = _createTextVNode(" zwischen 08:00 und 20:00 Uhr von DHL abgeholt. ", -1))
                                    ]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_44, [
                                        (_ctx.dhlLabelServed)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_45, "Das Paket im DHL Paketshop abgeben und zu uns senden."))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_46, "Das Paket in einem Paketshop abgeben und zu uns senden."))
                                    ])),
                                _createElementVNode("a", {
                                    href: "https://www.deutschepost.de/de/s/standorte.html?standorttyp=packstationen_paketboxen&pmtype=4",
                                    title: "Zum DHL Paketshop-Finder",
                                    target: "_blank",
                                    class: _normalizeClass(["buttonBase buttonBlueInverted w-100 [ track_red_link_dhl ]", { downloadButtonMobileView: _ctx.isMobile }])
                                }, " DHL Paketshop-Finder ", 2),
                                (!_ctx.dhlLabelServed)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createElementVNode("a", {
                                            href: "https://my.dpd.de/shopfinder.aspx",
                                            title: "Zum DPD Paketshop-Finder",
                                            target: "_blank",
                                            class: _normalizeClass(["buttonBase buttonBlueInverted w-100 mt-3 [ track_red_link_dpd ]", { downloadButtonMobileView: _ctx.isMobile }])
                                        }, " DPD Paketshop-Finder ", 2),
                                        _createElementVNode("a", {
                                            href: "https://www.myhermes.de/paketshop/",
                                            title: "Zum Hermes Paketshop-Finder",
                                            target: "_blank",
                                            class: _normalizeClass(["buttonBase buttonBlueInverted w-100 mt-3 mb-3 [ track_red_link_hermes ]", { downloadButtonMobileView: _ctx.isMobile }])
                                        }, " Hermes Paketshop-Finder ", 2)
                                    ], 64))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ]),
                (_ctx.dhlLabelServed)
                    ? (_openBlock(), _createElementBlock("article", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("a", {
                                        href: `/verkaufen/checkout/downloadAllAssets/${_ctx.order.id}`,
                                        type: "button",
                                        class: "buttonGreen w-100 [ track_red_alldocuments ]",
                                        download: "",
                                        target: "_blank"
                                    }, " Alles herunterladen ", 8, _hoisted_51),
                                    _cache[8] || (_cache[8] = _createElementVNode("p", { class: "font6-responsive text-center mt-4 strong" }, " Alle Informationen haben wir Dir auch per E-Mail zugeschickt. ", -1))
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (!_ctx.dhlLabelServed)
                    ? (_openBlock(), _createElementBlock("article", _hoisted_52, [...(_cache[9] || (_cache[9] = [
                            _createStaticVNode("<div class=\"col-12 bg-white border rounded py-3\" data-v-91a4306e><div class=\"row border-bottom\" data-v-91a4306e><div class=\"col-12 pr-0\" data-v-91a4306e><h2 class=\"h5 mb-3\" data-v-91a4306e>3. Versende Dein Paket an folgende Adresse</h2></div></div><div class=\"row\" data-v-91a4306e><div class=\"col-12 mt-4 pb-4 text-center\" data-v-91a4306e><div class=\"font5-responsive\" data-v-91a4306e><span data-v-91a4306e><span class=\"d-inline-block\" data-v-91a4306e>mySWOOOP</span> GmbH </span><br data-v-91a4306e><span data-v-91a4306e>Central Office</span><br data-v-91a4306e><span data-v-91a4306e>Linzer Str. 2</span><br data-v-91a4306e><span data-v-91a4306e>28359 Bremen</span></div></div></div></div>", 1)
                        ]))]))
                    : _createCommentVNode("", true)
            ])
        ])
    ], 64));
}
